export default "__VITE_ASSET__DdShFeW1__"